const scrollToTarget = (
  element: HTMLElement | null,
  headerOffSet: number = 64
) => {
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headerOffSet;

    window.scrollTo({
      top: offsetPosition,
      left: 0,
      behavior: "smooth",
    });
  }
};

export default scrollToTarget;
